export const POPOVER = {
  DEFAULT_BACKGROUND_COLOR: '#f7f7f7',
  DEFAULT_HEADER_BACKGROUND_COLOR: '#ffffff',
  DEFAULT_ICON_COLOR: '#bbbbbb'
};
